import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.male,
    new Map([
      [
        RiskLevel.Low,
        [
          {
            lower: 20,
            upper: 76,
          },
        ],
      ],
      [
        RiskLevel.Medium,
        [
          {
            lower: 76,
            upper: 84,
          },
        ],
      ],
      [
        RiskLevel.High,
        [
          {
            lower: 84,
          },
        ],
      ],
    ]),
  ],
  [
    Gender.female,
    new Map([
      [
        RiskLevel.Low,
        [
          {
            lower: 20,
            upper: 82,
          },
        ],
      ],
      [
        RiskLevel.Medium,
        [
          {
            lower: 82,
            upper: 89,
          },
        ],
      ],
      [
        RiskLevel.High,
        [
          {
            lower: 89,
          },
        ],
      ],
    ]),
  ],
]);

export default referenceRange;
